import { render } from "./liquidationReportCard.vue?vue&type=template&id=39b02440"
import script from "./liquidationReportCard.vue?vue&type=script&lang=js"
export * from "./liquidationReportCard.vue?vue&type=script&lang=js"

import "./liquidationReportCard.vue?vue&type=style&index=0&id=39b02440&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__